module.exports = __webpack_public_path__ + "static/img/logo.89178b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xihu/logo.png
// module id = J3Ke
// module chunks = 71